"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n            cursor: pointer;\n            position: relative;\n            display: inline-block;\n            color: ", ";\n            font-size: ", "em;\n            margin-left: ", "em;\n            margin-bottom: ", "em;\n        "], ["\n            cursor: pointer;\n            position: relative;\n            display: inline-block;\n            color: ", ";\n            font-size: ", "em;\n            margin-left: ", "em;\n            margin-bottom: ", "em;\n        "]),
    _templateObject2 = _taggedTemplateLiteral(["\n            border-radius: 14px;\n            position: absolute;\n            font-weight: bold;\n            text-align: center;\n            top: ", "em;\n            right: ", "em;\n            min-width: ", "em;\n            font-size: ", "em;\n            color: ", ";\n            background: ", ";\n        "], ["\n            border-radius: 14px;\n            position: absolute;\n            font-weight: bold;\n            text-align: center;\n            top: ", "em;\n            right: ", "em;\n            min-width: ", "em;\n            font-size: ", "em;\n            color: ", ";\n            background: ", ";\n        "]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _icon = require("../icon");

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserInfoIcon = function (_Component) {
    _inherits(UserInfoIcon, _Component);

    function UserInfoIcon() {
        _classCallCheck(this, UserInfoIcon);

        return _possibleConstructorReturn(this, (UserInfoIcon.__proto__ || Object.getPrototypeOf(UserInfoIcon)).apply(this, arguments));
    }

    _createClass(UserInfoIcon, [{
        key: "render",
        value: function render() {
            var UserInfoIcon = _styledComponents2.default.a(_templateObject, function (props) {
                return props.theme.userInfo.icon.color;
            }, function (props) {
                return props.theme.userInfo.icon.size;
            }, function (props) {
                return props.theme.userInfo.spacingX;
            }, function (props) {
                return props.theme.userInfo.spacingY;
            });
            var Notification = _styledComponents2.default.div(_templateObject2, function (props) {
                return props.theme.userInfo.notification.top;
            }, function (props) {
                return props.theme.userInfo.notification.right;
            }, function (props) {
                return props.theme.userInfo.notification.minWidth;
            }, function (props) {
                return props.theme.userInfo.notification.size;
            }, function (props) {
                return props.theme.userInfo.notification.color;
            }, function (props) {
                return props.theme.userInfo.notification.backgroundColor;
            });

            var _props = this.props,
                children = _props.children,
                notifications = _props.notifications,
                rest = _objectWithoutProperties(_props, ["children", "notifications"]);

            return _react2.default.createElement(
                UserInfoIcon,
                rest,
                children,
                notifications && _react2.default.createElement(
                    Notification,
                    null,
                    notifications
                )
            );
        }
    }]);

    return UserInfoIcon;
}(_react.Component);

UserInfoIcon.propTypes = {};

UserInfoIcon.defaultProps = {};

exports.default = UserInfoIcon;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/userInfo/userInfoIcon.js
// module id = 1025
// module chunks = 95715928098905 168707334958949